module.exports = __webpack_public_path__ + "img/DuplicateIcon.edad7bb5.svg";